import { render, staticRenderFns } from "./ProductRecommList.vue?vue&type=template&id=132bb374&scoped=true&"
import script from "./ProductRecommList.vue?vue&type=script&lang=js&"
export * from "./ProductRecommList.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommList.vue?vue&type=style&index=0&id=132bb374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132bb374",
  null
  
)

export default component.exports